export function buildAnalysisUnlockQuery({ source = 'analysis' } = {}) {
  return {
    redirect: 'analysis',
    unlock: '1',
    unlockSource: source,
    buyCredits: '1',
  };
}

export function readAnalysisUnlockIntent(query = {}) {
  return {
    shouldResumeUnlock: query.redirect === 'analysis' && query.unlock === '1',
    unlockSource: query.unlockSource || 'analysis',
    shouldOpenPurchase: query.buyCredits === '1',
  };
}

export function clearAnalysisUnlockQuery(query = {}) {
  const next = { ...query };
  if (next.redirect === 'analysis') {
    delete next.redirect;
  }
  delete next.unlock;
  delete next.unlockSource;
  delete next.buyCredits;
  return next;
}
